import { render, staticRenderFns } from "./NestedMenu.vue?vue&type=template&id=4a756224&"
import script from "./NestedMenu.vue?vue&type=script&lang=js&"
export * from "./NestedMenu.vue?vue&type=script&lang=js&"
import style0 from "./NestedMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports